export default "__VITE_ASSET__D7dg44Pt__"